
import { Component, Watch, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import currencyOptionMixin from '@/mixin/currencyOption'
import { getProductList, setProductInfo } from '@/api/product/product'
import {
  getProductAccountList,
  delProductAccount,
  getProductAccount,
  setProductAccount,
  closeCircuitbBreaker,
  shareAccount,
  getServerSidePlugin,
  getLoadingState,
  getAccountKey,
  setBatchEditLimit,
  delProductAccounts,
  batchEnable
} from '@/api/product/productAccount'
import addAccount from './components/addAccount.vue'
import editAccount from './components/editAccount.vue'
import statistical from './components/statistical.vue'
import pagination from '@/components/Pagination/index.vue'
import productInfo from './components/productInfo.vue'
import editProductBank from './components/editProductBank.vue'
import ylpayExtra from './components/ylpayExtra.vue'
import indiaQrExtra from './components/indiaQrExtra.vue'
import indExtra from './components/indExtra.vue'
import indiaExtra from './components/IndiaH5Extra.vue'
import trueh5Extra from './components/trueh5Config.vue'
import impsExtra from './components/impsExtra.vue'
import thaiQRExtra from './components/thaiQRExtra.vue'
import rmQRExtra from './components/rmqrExtra.vue'
import thaiExtraParam from './components/thaiExtraParam.vue'
import indusdt from './components/indusdt.vue'
import { clipboardSuccess } from '@/utils/clipboard'
import usdtExtra from './components/usdtExtra.vue'
import { onlinestatusList, statusList } from '@/utils/constant'
import { operationMessage } from '@/utils/message'
import { isShowDialog } from '@/utils/permission'
import { AppModule } from '@/store/modules/app'
import { getAccountGroupList } from '@/api/product/accountGroup'
import { getType, getProduct, setProduct } from '@/utils/cookies'
import sendApp from './components/sendApp.vue'
import notice from './components/notice.vue'
import allNotice from './components/allNotice.vue'
import subProduct from './subProduct/index.vue'
import { Form as ElForm } from 'element-ui'
import { timeJoin } from '@/utils/dateTime'
import { addItem, removeItem, removeItemTime } from '@/utils/arrays'

@Component({
  name: 'productList',
  components: {
    addAccount,
    editAccount,
    pagination,
    statistical,
    productInfo,
    editProductBank,
    indiaQrExtra,
    indExtra,
    indiaExtra,
    thaiExtraParam,
    usdtExtra,
    ylpayExtra,
    trueh5Extra,
    indusdt,
    impsExtra,
    thaiQRExtra,
    rmQRExtra,
    sendApp,
    notice,
    allNotice,
    subProduct
  }
})
export default class extends mixins(currencyOptionMixin) {
  @Prop({ default: 'payment' }) type!: string
  queryForm: any = {
    currency: AppModule.currentCurrencyType,
    account_name: '',
    account_no: '',
    account_type: '',
    account_group: '',
    status: null,
    state: null,
    product: null,
    product_account: null
  }
  private addItem = addItem
  // private removeItem = removeItem
  private removeItem = removeItemTime
  productList: any[] = []
  private currentProduct: any = {
    id: ''
  } // 当前选中的产品对象
  private infoForm: any = {
    product: null,
    product_account: null
  }
  private shareCurrency = AppModule.enterprise.available_crypto_currency
  private accountList: any[] = []
  private currentAccountId: any = {}
  private listLoading: boolean = true
  private dialogVisible: boolean = false
  private isDrawerVisible: boolean = false
  private currentProductDetail: any = {}
  private centerDrawerVisible: boolean = false
  private activeName: any = 'first'
  private drawer: boolean = false
  private statusList = statusList
  private stateList = onlinestatusList
  private accountGroup: any = []
  private timer: any = []
  private productAccountList: any[] = []
  private clipboardSuccess = clipboardSuccess

  private tabName: string = 'basicInformation'
  private action: string = ''
  private total = 0
  private listQuery = {
    page: 1,
    limit: 20
  }
  private inRoOut: any = null
  private onProductList: any[] = []
  private currentId: any = ''

  private prouductLoading: boolean = false
  @Watch('onProductList')
  watchArr(newValue: any[], oldValue: any[]) {
    let product: any = getProduct()
    let arr: any = this.onProductList.filter((item: any) => {
      return item.id === product - 0
    })
    if (arr.length > 0) {
      this.currentProduct = arr[0]
      this.currentId = arr[0].id
      this.inRoOut = this.currentProduct.in_or_out
      this.prouductLoading = false
    } else {
      if (this.onProductList.length > 0) {
        setProduct(this.onProductList[0].id)
        this.currentId = this.onProductList[0].id
        this.currentProduct = this.onProductList[0]
        this.inRoOut = this.currentProduct.in_or_out
        this.prouductLoading = false
      } else {
        this.prouductLoading = true
        if (this.language === 'en') {
          this.$message({
            message: 'No product available!',
            type: 'error'
          })
        } else if (this.language === 'zh_cn') {
          this.$message({
            message: '没有可用产品!',
            type: 'error'
          })
        } else if (this.language === 'zh_tw') {
          this.$message({
            message: '沒有可用產品!',
            type: 'error'
          })
        }
      }
    }
    // this.getProductDetail()
  }

  @Watch('currentId')
  private wacthProduct() {
    this.currentPage = 1
    setProduct(this.currentId)
    this.getAccountGroupList(this.currentId)
    this.hadleGetFilesListApi(false)
    this.getProductDetail()
  }

  // 货币切换
  private async currencyChange() {
    AppModule.SetCurrentCurrencyType(this.queryForm.currency)
    this.infoForm.currency = null
    this.infoForm.product = null
    this.infoForm.product_account = null
    this.queryForm.account_name = ''
    this.queryForm.account_no = ''
    this.queryForm.account_type = ''
    this.queryForm.account_group = ''
    this.queryForm.status = null
    this.getProductLists()
    // await this.hadleGetFilesListApi(false)
  }

  // 产品切换
  private async selProduct(row: any) {
    this.inRoOut = row.in_or_out
    this.queryForm.account_name = ''
    this.queryForm.account_no = ''
    this.queryForm.account_type = ''
    this.queryForm.account_group = ''
    this.queryForm.status = null
    this.currentPage = 1
    let arr: any = this.onProductList.filter((item: any) => {
      return item.id === row - 0
    })
    this.currentProduct = arr[0]
    this.inRoOut = arr.in_or_out
    // await this.hadleGetFilesListApi(false)
  }

  // 分享账户
  private shareVisible: boolean = false
  private shareObj: any = {}
  private share(row: any) {
    this.shareObj = row
    this.shareVisible = true
  }
  private shareAccountlist: any[] = []
  private shareProductList: any[] = []

  private closeShare() {
    this.shareVisible = false
    this.infoForm.currency = null
    this.infoForm.product = null
    this.infoForm.product_account = null
    this.shareAccountlist = []
    this.shareProductList = []
  }

  private productChange() {
    this.infoForm.product_account = null
    this.getshareAccount()
  }
  private sharechange() {
    this.infoForm.product = null
    this.infoForm.product_account = null
    this.getshareProduct()
  }

  // 关闭抽屉
  private closeDialogVisibleDetail() {
    this.isDrawerVisible = false
  }

  private closeDialog(b: boolean) {
    this.centerDrawerVisible = b
  }

  // 批量编辑限额
  private limitArrList: any[] = []
  private editLimitArr: any[] = []
  private editLimitForm: any = {
    ids: '',
    min_amount: '',
    max_amount: '',
    daily_limited_transaction: '',
    status: '',
    daily_limited_volume: '',
    open_time: []
  }
  private openTimes: any[] = [
    [new Date('2024/01/01 00:00'), new Date('2024/01/01 23:59')]
  ]
  private handleSelectionChange(list) {
    this.limitArrList = list
  }

  private openEditLimit: boolean = false
  private async batchEditLimit() {
    this.editLimitArr = []
    for (let i = 0; i < this.limitArrList.length; i++) {
      this.editLimitArr.push(this.limitArrList[i].id)
    }
    this.editLimitForm.ids = this.editLimitArr.join(',')
    this.openEditLimit = true
  }
  private checkUpload: boolean = false
  private async onEditLimitSubmit() {
    if (this.checkUpload === true) {
      this.openTimes.forEach((time: any) => {
        if (time[0]) {
          const str = timeJoin(time[0], time[1])
          this.editLimitForm.open_time.push(str)
        }
      })
    } else {
      delete this.editLimitForm.open_time
    }
    const data: any = {
      ...this.editLimitForm
    }
    await setBatchEditLimit(data).then(() => {
      if (this.language === 'en') {
        this.$message({
          message: 'Operation successfully!',
          type: 'success'
        })
      } else if (this.language === 'zh_cn') {
        this.$message({
          message: '操作成功!',
          type: 'success'
        })
      } else if (this.language === 'zh_tw') {
        this.$message({
          message: '操作成功!',
          type: 'success'
        })
      }
    })
    this.closeEditLimit()
  }
  private closeEditLimit() {
    this.openEditLimit = false
    this.editLimitForm = {
      ids: '',
      min_amount: '',
      max_amount: '',
      daily_limited_transaction: '',
      status: '',
      daily_limited_volume: '',
      open_time: []
    }
    this.openTimes = [
      [new Date('2024/01/01 00:00'), new Date('2024/01/01 23:59')]
    ]
    this.checkUpload = false
    this.hadleGetFilesListApi(false)
  }

  private openDel: boolean = false
  private delAccounts: any[] = []
  private delForm: any = {
    ids: '',
    description: '',
    google_code: ''
  }
  private async batchDel() {
    let delArr: any[] = []
    for (let i = 0; i < this.limitArrList.length; i++) {
      delArr.push(this.limitArrList[i].id)
      this.delAccounts.push(this.limitArrList[i].account_name)
    }
    this.delForm.ids = delArr.join(',')
    this.openDel = true
  }

  private closeDel() {
    this.delAccounts = []
    this.delForm = {
      ids: '',
      description: '',
      google_code: ''
    }
    this.openDel = false
    this.hadleGetFilesListApi(false)
  }

  private async onDelSubmit() {
    ;(this.$refs.delForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        const data: any = {
          ...this.delForm
        }
        await delProductAccounts(data).then(() => {
          if (this.language === 'en') {
            this.$message({
              message: 'Delete successfully!',
              type: 'success'
            })
          } else if (this.language === 'zh_cn') {
            this.$message({
              message: '删除成功!',
              type: 'success'
            })
          } else if (this.language === 'zh_tw') {
            this.$message({
              message: '删除成功!',
              type: 'success'
            })
          }
          this.closeDel()
        })
      } else {
        return false
      }
    })
  }

  // 分享账户单独获取账户列表
  private async getshareAccount() {
    try {
      const data: any = {
        product: this.infoForm.product
      }
      await getProductAccountList(data).then((res: any) => {
        this.shareAccountlist = res.results
      })
    } catch (e) {}
  }

  // 分享账户单独获取产品列表
  private async getshareProduct() {
    try {
      const data: any = {
        status: 1,
        currency: this.infoForm.currency,
        in_or_out: this.inRoOut
      }
      await getProductList(data).then((res: any) => {
        this.shareProductList = res
      })
    } catch (e) {}
  }

  private async saveShare() {
    try {
      const data: any = {
        product: this.infoForm.product,
        product_account: this.shareObj.id
      }
      await shareAccount(data).then(() => {
        this.$message({
          message: 'Successful Share',
          type: 'success'
        })
        this.shareVisible = false
      })
    } catch (e) {}
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi(false)
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi(false)
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi(flag) {
    try {
      if (this.timer.length > 0) {
        this.clearTime()
      }
      if (!flag) {
        this.listLoading = true
        this.accountList = []
      }
      if (this.type !== 'payment') {
        this.queryForm.ant_username = this.type
      }
      const params = {
        ...this.queryForm,
        product: this.currentId,
        page_size: this.pagesize,
        page: this.currentPage
      }
      await getProductAccountList(params).then((res: any) => {
        this.total = res.count
        this.accountList = res.results
        this.listLoading = false
        this.accountList.forEach(item => {
          item.startLoading = false
          item.reloadLoading = false
          item.stopLoading = false
          item.unlockLoading = false
          if (item.server_side_loading) {
            let timer = setInterval(() => {
              setTimeout(() => {
                this.changeLoadingState(item)
              }, 0)
            }, 3000)
            this.timer.push(timer)
          }

          if (typeof item.hook_balance === 'string') {
            let content: any = item.hook_balance.split('(')
            if (content.length > 0) {
              item.newValue = {
                one: content[0],
                two: content.length > 1 ? '(' + content[1] : ''
              }
            }
          }
        })
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  // 查询插件loading状态
  private async changeLoadingState(row) {
    try {
      const data = {
        id: row.id
      }
      await getLoadingState(data).then((res: any) => {
        if (!res.server_side_loading) {
          this.hadleGetFilesListApi(true)
        } else {
          this.accountList.forEach((item, index) => {
            if (item.id === res.id) {
              item.hook_info = res.hook_info
              item.upstream_remarks = res.upstream_remarks
              this.$set(this.accountList, index, item)
            }
          })
        }
        if (res.need_sms) {
          this.otpDialogVisible = true
          this.otpFormDetail.account_no = row.account_no
          this.otpFormDetail.account_name = row.account_name
          this.otpObj = {
            row: row,
            action: 'start'
          }
        }
      })
    } catch (e) {}
  }

  get language() {
    return AppModule.language
  }

  private async setStatus(account: any, str: string) {
    let data: any = {}
    if (str === 'status') {
      data = {
        id: account.id,
        status: account.status
      }
    } else {
      data = {
        id: account.id,
        extra_param: {
          ...account.extra_param,
          bot_cars_switch: account.bot_cars_switch
        }
      }
    }
    try {
      await setProductAccount(data).then((res: any) => {
        this.$message({
          message: 'Save successful!',
          type: 'success'
        })
        this.hadleGetFilesListApi(false)
      })
    } catch (e) {
      account.status = status
    }
  }

  // 更改产品详情
  private async setProductStatus(obj: any) {
    const status = obj.status === 0 ? 1 : 0
    const data: any = {
      id: obj.id,
      status: obj.status
    }
    try {
      await setProductInfo(data).then((res: any) => {
        if (this.language === 'en') {
          this.$message({
            message: 'Save successful!',
            type: 'success'
          })
        }
        if (this.language === 'zh_cn') {
          this.$message({
            message: '保存成功!',
            type: 'success'
          })
        }
        if (this.language === 'zh_tw') {
          this.$message({
            message: '保存成功!',
            type: 'success'
          })
        }
      })
    } catch (e) {
      obj.status = status
    }
  }

  // 获取当前行的样式
  private getRowClassName({ row, rowIndex }) {
    let classname = 'autofix-table-row '
    // 通过判断给不需要展开行功能的数据设置样式，通过样式去隐藏展开行图标
    if (!row.server_side_plugin) {
      classname += ' hide-expand'
    }
    return classname
  }

  private sortChange(column, prop, order) {
    // 点击排序按钮后拿到column.order，可以发送column.order给后台，后台再根据什么排序来返回排序过后的数据
    if (!column.order) {
      let el: any = this.$refs.table
      el.sort('data', 'ascending')
    }
    if (column.prop === 'daily_available_volume') {
      column.order === 'ascending'
        ? (this.queryForm.ordering = 'daily_available_volume')
        : column.order === 'descending'
        ? (this.queryForm.ordering = '-daily_available_volume')
        : (this.queryForm.ordering = null)
    } else if (column.prop === 'daily_available_transaction') {
      column.order === 'ascending'
        ? (this.queryForm.ordering = 'daily_available_transaction')
        : column.order === 'descending'
        ? (this.queryForm.ordering = '-daily_available_transaction')
        : (this.queryForm.ordering = null)
    } else if (column.prop === 'today_deposit_amount') {
      column.order === 'ascending'
        ? (this.queryForm.ordering = 'today_deposit_amount')
        : column.order === 'descending'
        ? (this.queryForm.ordering = '-today_deposit_amount')
        : (this.queryForm.ordering = null)
    } else if (column.prop === 'daily_rate') {
      column.order === 'ascending'
        ? (this.queryForm.ordering = 'daily_rate')
        : column.order === 'descending'
        ? (this.queryForm.ordering = '-daily_rate')
        : (this.queryForm.ordering = null)
    } else if (column.prop === 'balance') {
      column.order === 'ascending'
        ? (this.queryForm.ordering = 'balance')
        : column.order === 'descending'
        ? (this.queryForm.ordering = '-balance')
        : (this.queryForm.ordering = null)
    } else if (column.prop === 'freeze_balance') {
      column.order === 'ascending'
        ? (this.queryForm.ordering = 'freeze_balance')
        : column.order === 'descending'
        ? (this.queryForm.ordering = '-freeze_balance')
        : (this.queryForm.ordering = null)
    }
    this.hadleGetFilesListApi(false)
    // 输出的结果 [object Object]---name---ascending
  }

  // APP系统通知
  private sendAppVisible: boolean = false
  private antName: string = ''
  private sendAntName: any = ''
  private openSendApp(name) {
    console.log(name)

    this.sendAppVisible = true
    this.antName = name.ant_account
    this.sendAntName = name.username
    this.$nextTick(() => {
      let el: any = this.$refs['sendAppBtn']
      el.init()
    })
  }
  private closeSendApp() {
    this.sendAppVisible = false
  }

  private closeDrawer() {
    // this.drawer = false
    this.tabName = 'basicInformation'
    this.getProductLists()
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi(false)
  }

  private reset() {
    if (this.sysType === 'ant') {
      this.queryForm.ant_username = ''
    }
    this.queryForm.account_name = ''
    this.queryForm.account_no = ''
    this.queryForm.account_type = ''
    this.queryForm.account_group = ''
    this.queryForm.status = null
    this.queryForm.ordering = null
    let el: any = this.$refs.table
    el.clearSort()
    this.currentPage = 1
    this.getProductLists()
    this.hadleGetFilesListApi(false)
  }

  // 获取产品列表
  private async getProductLists() {
    const data: any = {
      currency: this.queryForm.currency,
      status: 1
    }
    await getProductList(data).then((res: any) => {
      this.productList = res
      this.onProductList = this.productList.filter((item: any) => {
        return this.queryForm.currency === item.currency
      })
      // if (this.productList.length >= 1) {
      //   this.currentProduct = this.currentProduct.id
      //     ? this.currentProduct
      //     : this.productList
      // }
    })
  }

  // 获取产品详情
  private getProductDetail() {
    let product: any = getProduct()
    let productDetail: any = this.onProductList.filter((item: any) => {
      return item.id === product - 0
    })
    this.currentProductDetail = productDetail[0]
    // console.log(productDetail[0].extra_param, 'productDetail')
    console.log(this.currentProductDetail)
  }

  // 打开产品详情抽屉
  isShowDrawer() {
    this.isDrawerVisible = true
    this.activeName = 'first'
  }

  // 获取账户组列表
  private async getAccountGroupList(id: any) {
    const params = {
      product: id
    }
    await getAccountGroupList(params).then((res: any) => {
      this.accountGroup = res.results
    })
  }

  private getAccountName(row) {
    if (!row.length) return []
    const eleIsInArr = (ele, arr) => arr.some(m => m === ele.id)
    return this.accountGroup.filter(x => eleIsInArr(x, row))
  }

  private getStatus(status: string, row: any, flag: boolean) {
    if (status === 'stop') {
      this.$set(row, 'stopLoading', flag)
    } else if (status === 'start') {
      this.$set(row, 'startLoading', flag)
    } else if (status === 'reload') {
      this.$set(row, 'reloadLoading', flag)
    } else if (status === 'query') {
      this.$set(row, 'unlockLoading', flag)
    }
  }

  // 操作插件
  private otpDialogVisible: boolean = false
  private promptLoading: boolean = false
  private otpFormDetail: any = {
    account_no: '',
    account_name: '',
    otp: ''
  }
  private otpTips: string = ''
  private otpObj: any = {}
  private requiredOtp: string = ''
  private async changeServerSidePlugin(
    row: any,
    action: string,
    indexs: number
  ) {
    try {
      this.promptLoading = true
      const data = {
        action: action,
        product_account: row.id
      }
      await getServerSidePlugin(data)
        .then((res: any) => {
          this.promptLoading = false
          if (res.need_sms) {
            this.otpDialogVisible = true
            this.otpFormDetail.account_no = row.account_no
            this.otpFormDetail.account_name = row.account_name
            this.otpTips = res.otpRefNo
            this.otpObj = {
              row: row,
              action: action,
              indexs: indexs
            }
          } else {
            this.getStatus(action, row, true)
            this.$message({
              message: 'Send command successfully',
              type: 'success'
            })
            this.promptLoading = false
            if (action === 'stop') {
              this.promptLoading = false
              row.server_side_loading = true
            } else if (action === 'start') {
              this.promptLoading = false
              row.server_side_loading = true
            } else if (action === 'reload') {
              this.promptLoading = false
              row.server_side_loading = true
            }
            this.$set(this.accountList, indexs, row)
            let timer = setInterval(() => {
              setTimeout(() => {
                this.changeLoadingState(row)
              }, 0)
            }, 3000)
            this.timer.push(timer)
          }
        })
        .catch(e => {
          this.promptLoading = false
        })
    } catch (e) {
      this.getStatus(action, row, false)
      this.promptLoading = false
    }
  }

  // 关闭弹框
  private otpHandleClose() {
    this.otpFormDetail.account_no = ''
    this.otpFormDetail.account_name = ''
    this.otpObj = {}
    this.requiredOtp = ''
    this.otpFormDetail.otp = ''
    this.otpDialogVisible = false
  }

  // 验证otp
  private otpLoading: boolean = false
  private async getOtpVerification() {
    if (!this.otpFormDetail.otp) {
      return (this.requiredOtp = 'Please enter the OTP verification code')
    }
    this.getStatus(this.otpObj.action, this.otpObj.row, true)
    this.otpLoading = true
    try {
      const data = {
        action: 'verify_otp',
        product_account: this.otpObj.row.id,
        data: {
          otp: this.otpFormDetail.otp
        }
      }
      await getServerSidePlugin(data)
        .then((res: any) => {
          this.$message({
            message: 'Send command successfully',
            type: 'success'
          })
          this.otpDialogVisible = false
          this.otpLoading = false
          if (this.otpObj.action === 'stop') {
            this.otpObj.row.server_side_loading = false
          } else if (this.otpObj.action === 'start') {
            this.otpObj.row.server_side_loading = true
          } else if (this.otpObj.action === 'reload') {
            this.otpObj.row.server_side_loading = true
          }
          // this.$set(this.accountList, this.otpObj.indexs, this.otpObj.row)
          let timer = setInterval(() => {
            setTimeout(() => {
              this.changeLoadingState(this.otpObj.row)
            }, 0)
          }, 3000)
          this.timer.push(timer)
          this.otpFormDetail.otp = ''
        })
        .catch(e => {
          this.otpLoading = false
        })
    } catch (e) {
      this.getStatus(this.otpObj.action, this.otpObj.row, false)
      this.otpLoading = false
    }
  }

  private timeRules: any = {
    old_pin: [
      { required: true, message: 'Please input old pin', trigger: 'blur' }
    ],
    new_pin: [
      { required: true, message: 'Please input new pin', trigger: 'blur' }
    ]
  }
  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }
  private pinInfo: any = {}
  private botCarsTime: boolean = false
  private pinForm: any = {
    old_pin: '',
    new_pin: ''
  }
  private getChangePin(row) {
    this.pinInfo = row
    this.botCarsTime = true
  }
  private closeBotTime() {
    this.pinForm = {
      old_pin: '',
      new_pin: ''
    }
    this.botCarsTime = false
  }
  private async changeBotTime() {
    ;(this.$refs.timeForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.flag = true
          const data = {
            action: 'change_pin',
            product_account: this.pinInfo.id,
            data: {
              ...this.pinForm
            }
          }
          await getServerSidePlugin(data)
            .then((res: any) => {
              this.$message({
                message: 'Pin changed successfully!',
                type: 'success'
              })
              this.flagStr()
              this.closeBotTime()
            })
            .catch(e => {
              this.flagStr()
            })
        } catch (e) {
          this.flagStr()
        }
      }
    })
  }

  // 获取日志key
  private async getAccountLog(row) {
    try {
      let data = {
        id: row.id
      }
      await getAccountKey(data).then((res: any) => {
        // this.$router.push({
        //   name:"/accountLog",
        //   // query:{id：item.id}
        // })
        localStorage.setItem('queryKey', res.key)
        localStorage.setItem('queryId', row.id)
        window.open('/accountLog', '_blank')
      })
    } catch (e) {
      console.log(e)
    }
  }

  // 远程查询
  private async remoteQuery(query: string) {
    const data = {
      name: query,
      product: this.currentId
    }
    await getAccountGroupList(data).then((res: any) => {
      this.accountGroup = res.results
    })
  }

  // 删除产品账户
  private del(id: number) {
    if (this.language === 'en') {
      this.$confirm('Are you sure to delete it?', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning',
        callback: action => {
          if (action === 'confirm') {
            this.currentAccountId = id
            isShowDialog('delete_product_account')
              ? this.openDialogVisible('del')
              : this.delProductAccount({ id: this.currentAccountId })
          }
        }
      })
    }
    if (this.language === 'zh_cn') {
      this.$confirm('确定要删除吗？ ', {
        confirmButtonText: '是的 ',
        cancelButtonText: '取消',
        type: 'warning',
        callback: action => {
          if (action === 'confirm') {
            this.currentAccountId = id
            isShowDialog('delete_product_account')
              ? this.openDialogVisible('del')
              : this.delProductAccount({ id: this.currentAccountId })
          }
        }
      })
    }
    if (this.language === 'zh_tw') {
      this.$confirm('確定要刪除嗎？ ', {
        confirmButtonText: '是的 ',
        cancelButtonText: '取消',
        type: 'warning',
        callback: action => {
          if (action === 'confirm') {
            this.currentAccountId = id
            isShowDialog('delete_product_account')
              ? this.openDialogVisible('del')
              : this.delProductAccount({ id: this.currentAccountId })
          }
        }
      })
    }
  }

  private async delProductAccount(data: any) {
    await delProductAccount(data).then(() => {
      operationMessage(true)
    })
  }

  private openDialogVisible(action: string) {
    this.action = action
    this.dialogVisible = true
  }

  private closeDialogVisible() {
    this.dialogVisible = false
    this.hadleGetFilesListApi(false)
  }

  private async operationCb(info: any) {
    if (info) {
      const data: any = {
        id: this.currentAccountId,
        ...info
      }
      await this.delProductAccount(data)
    }
    this.dialogVisible = false
  }

  private accountType: string = ''
  private inOrOut: number | null = null
  private async openEdit(row: any) {
    this.currentAccountId = row.id
    this.accountType = row.account_type
    this.inOrOut = row.in_or_out
    this.drawer = true
  }

  private async breaker(row: any) {
    try {
      const data: any = {
        id: row.id
      }
      await closeCircuitbBreaker(data).then(() => {
        this.$message('Successful operation')
      })
    } catch (e) {}
  }

  clearTime() {
    this.timer.forEach(element => {
      window.clearInterval(element)
    })
    this.timer = []
  }

  private selectAll(val) {
    this.selectList = val
    let newList: any = []
    let accountList: any = []
    this.selectList.map((item: any) => {
      if (item.ant_account || item.username !== '') {
        newList.push(item.ant_account)
        accountList.push(item.username)
      }
    })
    this.antNameList = Array.from(new Set(newList))
    this.antAccountList = Array.from(new Set(accountList))
  }
  //选择某行
  private selectTr(selection, row) {
    this.selectList = selection
    let newList: any = []
    let accountList: any = []
    this.selectList.map((item: any) => {
      if (item.ant_account || item.username) {
        newList.push(item.ant_account)
        accountList.push(item.username)
      }
    })
    this.antNameList = Array.from(new Set(newList))
    this.antAccountList = Array.from(new Set(accountList))
  }

  private selectList: any = []
  private bulkLoginVisble: boolean = false
  private allNoticeVisble: boolean = false
  private antNameList: any = []
  private antAccountList: any = []
  private getNotice() {
    if (this.antNameList.length === 0) {
      this.allNoticeVisble = true
    } else {
      this.bulkLoginVisble = true
      this.$nextTick(() => {
        let el: any = this.$refs['notice']
        el.init()
      })
    }
  }

  // 批量启用
  private async batchActivation() {
    this.editLimitArr = []
    for (let i = 0; i < this.limitArrList.length; i++) {
      if (
        this.limitArrList[i].state === 0 ||
        this.limitArrList[i].state === 3
      ) {
        this.editLimitArr.push(this.limitArrList[i].id)
      }
    }
    let arr = this.editLimitArr
    await batchEnable({ product_account: arr, action: 'start' }).then(() => {
      if (this.language === 'en') {
        this.$message({
          message: 'Operation successfully!',
          type: 'success'
        })
      } else if (this.language === 'zh_cn') {
        this.$message({
          message: '操作成功!',
          type: 'success'
        })
      } else if (this.language === 'zh_tw') {
        this.$message({
          message: '操作成功!',
          type: 'success'
        })
      }
      setTimeout(() => {
        this.hadleGetFilesListApi(false)
      }, 1000)
    })
  }

  // 批量重启
  private async batchRestart() {
    this.editLimitArr = []
    for (let i = 0; i < this.limitArrList.length; i++) {
      this.editLimitArr.push(this.limitArrList[i].id)
    }
    let arr = this.editLimitArr
    await batchEnable({ product_account: arr, action: 'reload' }).then(() => {
      if (this.language === 'en') {
        this.$message({
          message: 'Operation successfully!',
          type: 'success'
        })
      } else if (this.language === 'zh_cn') {
        this.$message({
          message: '操作成功!',
          type: 'success'
        })
      } else if (this.language === 'zh_tw') {
        this.$message({
          message: '操作成功!',
          type: 'success'
        })
      }
      setTimeout(() => {
        this.hadleGetFilesListApi(false)
      }, 1000)
    })
  }

  // 批量停用
  private async batchDisable() {
    this.editLimitArr = []
    for (let i = 0; i < this.limitArrList.length; i++) {
      if (this.limitArrList[i].state === 1) {
        this.editLimitArr.push(this.limitArrList[i].id)
      }
    }
    let arr = this.editLimitArr
    await batchEnable({ product_account: arr, action: 'stop' }).then(() => {
      if (this.language === 'en') {
        this.$message({
          message: 'Operation successfully!',
          type: 'success'
        })
      } else if (this.language === 'zh_cn') {
        this.$message({
          message: '操作成功!',
          type: 'success'
        })
      } else if (this.language === 'zh_tw') {
        this.$message({
          message: '操作成功!',
          type: 'success'
        })
      }
      setTimeout(() => {
        this.hadleGetFilesListApi(false)
      }, 1000)
    })
  }

  private closeBulkLogin() {
    this.antNameList = []
    this.antAccountList = []
    this.selectList = []
    this.bulkLoginVisble = false
    this.allNoticeVisble = false
    this.hadleGetFilesListApi(false)
  }

  private sysType: any = ''

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    this.sysType = getType()
    this.getProductLists()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.accountManage`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
  destroyed() {
    this.timer.forEach(element => {
      window.clearInterval(element)
    })
    this.timer = []
  }
}
